import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../../components/hooks/useAuth";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useEffect, useState } from "react";
import { getLocations } from "../../../../services/location";
import axios from "axios";
import baseURL from "../../../../configs/api";
import Select from "react-select";
import { validateMin } from "../../../../utils/validateMin";
import { Button } from "@mui/material";
import colorConfigs from "../../../../configs/colorConfigs";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import useDelete from "../../../../components/hooks/useDelete";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";


export const EditRelocationMapping = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { themeStyles } = useTheme();
    const idNumber = useLocation();
    const navigate = useNavigate();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [AllFromLocationVehicleClassesOptions, setAllFromLocationVehicleClassesOptions] = useState<any[]>([]);
    const [AllToLocationVehicleClassesOptions, setAllToLocationVehicleClassesOptions] = useState<any[]>([]);
    const [allLocationsOptions, setAllLocationsOptions] = useState<any[]>([]);
    const [fromLocationId, setFromLocationId] = useState<number>(0);
    const [fromLocationBranchId, setFromLocationBranchId] = useState<number>(0);
    const [toLocationId, setToLocationId] = useState<number>(0);
    const [toLocationBranchId, setToLocationBranchId] = useState<number>(0);
    const [fromVehicleClassId, setFromVehicleClassId] = useState<number>(0);
    const [toVehicleClassId, setToVehicleClassId] = useState<number>(0);
    const [fromSecondaryVehicleClassId, setFromSecondaryVehicleClassId] = useState<number>(0);
    const [toSecondaryVehicleClassId, setToSecondaryVehicleClassId] = useState<number>(0);
    const [relocationCharge, setRelocationCharge] = useState<number>(0);
    const [createdAt, setCreatedAt] = useState<string>("");
    const [createdBy, setCreatedBy] = useState<string>("");
    const [disabled, setDisabled] = useState<boolean>(true);
    const [vehicleClasses, setVehicleClasses] = useState<any[]>([]);

    useEffect(() => {
        getLocations(tenantId)
            .then((data) => {
                setAllLocationsOptions(() =>
                    data?.map((item: any) => {
                        return {
                            value: item?.id,
                            label: item?.locationName,
                            branchId: item?.branchId
                        };
                    })
                );
                handleTenantError(null);
            })
            .catch((error) => {
                setAllLocationsOptions([]);
               handleTenantError(error);
            })

             // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        axios.get(`${baseURL}vehicleClass`, {
            headers: {
                'X-Tenant-ID': tenantId,
            }
        })
            .then((res) => {
                setVehicleClasses(res.data);
                handleTenantError(null);
            })
            .catch((error) => {
                setVehicleClasses([]);
               handleTenantError(error);
            })

             // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (fromLocationBranchId > 0) {
            if (vehicleClasses?.length > 0) {
                setAllFromLocationVehicleClassesOptions(() =>
                    vehicleClasses
                        ?.filter((item: any) => item?.branchId === fromLocationBranchId)
                        ?.map((item: any) => {
                            return {
                                value: item?.id, label: item?.name
                            };
                        })
                );
            } else {
                setAllFromLocationVehicleClassesOptions([]);
            }
        }
    }, [vehicleClasses, fromLocationBranchId])

    useEffect(() => {
        if (toLocationBranchId > 0) {
            if (vehicleClasses?.length > 0) {
                setAllToLocationVehicleClassesOptions(() =>
                    vehicleClasses
                        ?.filter((item: any) => item?.branchId === toLocationBranchId)
                        ?.map((item: any) => {
                            return {
                                value: item?.id, label: item?.name
                            };
                        })
                );
            } else {
                setAllToLocationVehicleClassesOptions([]);
            }
        }
    }, [vehicleClasses, toLocationBranchId])

    useEffect(() => {
        if (idNumber?.state && allLocationsOptions?.length > 0) {
            setPleaseWaitPopup(true);
            axios
                .get(`${baseURL}relocationMapping/${idNumber?.state}`, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                .then(response => {
                    setFromLocationId(response?.data?.fromLocationId)
                    setToLocationId(response?.data?.toLocationId)
                    setFromVehicleClassId(response?.data?.fromVehicleClassId)
                    setToVehicleClassId(response?.data?.toVehicleClassId)
                    setFromSecondaryVehicleClassId(response?.data?.fromSecondaryVehicleClassId)
                    setToSecondaryVehicleClassId(response?.data?.toSecondaryVehicleClassId)
                    setFromLocationBranchId(allLocationsOptions?.find((item: any) => item?.value === response?.data?.fromLocationId)?.branchId)
                    setToLocationBranchId(allLocationsOptions?.find((item: any) => item?.value === response?.data?.toLocationId)?.branchId)
                    setRelocationCharge(response?.data?.relocationCharge)
                    setCreatedBy(response?.data?.createdBy);
                    setCreatedAt(response?.data?.createdAt);
                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber?.state, allLocationsOptions]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (fromLocationId !== toLocationId) {
            setPleaseWaitPopup(true);
            await axios
                .put(
                    `${baseURL}relocationMapping?userId=${auth?.id}`,
                    JSON.stringify({
                        id: idNumber?.state,
                        fromLocationId,
                        toLocationId,
                        fromVehicleClassId,
                        toVehicleClassId,
                        fromSecondaryVehicleClassId,
                        toSecondaryVehicleClassId,
                        relocationCharge,
                        createdBy,
                        createdAt: new Date(createdAt).toLocaleDateString(),
                        updatedBy: auth?.givenname,
                        updatedAt: new Date().toLocaleString()
                    }),
                    {
                        headers: {
                            'X-Tenant-ID': tenantId,
                            "Content-Type": "application/json"
                        },
                        withCredentials: true,
                    }
                )
                .then(() => {
                    setPleaseWaitPopup(false);
                    navigate(-1);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        }
    }

    const deleteRelocationMapping = () => {
        setDeleteData({
            id: idNumber?.state,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Relocation Mapping?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);

                fetch(`${baseURL}relocationMapping?id=${idNumber?.state}&userId=${auth?.id}`, {
                    method: 'DELETE',
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWaitPopup(false);
                        handleTenantError(error);
                    });

                callback();
            }
        });

        setDeletePopup(true);
    }

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>
                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Relocation Mapping</h2>
                                </div>

                                {
                                    disabled && (
                                        <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                            onClick={() => setDisabled(false)}
                                        >
                                            <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                                edit
                                            </span>
                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                                        </button>
                                    )
                                }
                            </div>

                            {
                                (fromLocationId !== 0 && toLocationId !== 0) && (fromLocationId === toLocationId) && (
                                    <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                        From Location and To Location can not be same.
                                    </p>
                                )
                            }

                            <div className="w-3/4 mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2 mt-1.5">
                                        <div className="grid grid-cols-2 gap-6">
                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>From Location</label>
                                                    <Select
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: "transparent",
                                                                color: themeStyles.form.inputTextColor,
                                                                borderRadius: '6px',
                                                                padding: '1px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "14px",
                                                                backgroundColor: themeStyles.main.mainBg,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                            option: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: state.isSelected
                                                                    ? "#167AC3"
                                                                    : state.isFocused
                                                                        ? themeStyles.topBar.menuItemsHoverColor
                                                                        : "transparent",
                                                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                                fontWeight: 600
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,

                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isDisabled={disabled}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        required={true}
                                                        name="fromlocation"
                                                        value={allLocationsOptions.find(
                                                            (item) => item.value === fromLocationId
                                                        )}
                                                        onChange={(location: any) => {
                                                            setFromLocationId(
                                                                location ? location.value : 0
                                                            )
                                                            setFromLocationBranchId(location ? location.branchId : 0)
                                                        }}
                                                        options={allLocationsOptions}
                                                    />
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>From Vehicle Class</label>
                                                    <Select
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: "transparent",
                                                                color: themeStyles.form.inputTextColor,
                                                                borderRadius: '6px',
                                                                padding: '1px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "14px",
                                                                backgroundColor: themeStyles.main.mainBg,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                            option: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: state.isSelected
                                                                    ? "#167AC3"
                                                                    : state.isFocused
                                                                        ? themeStyles.topBar.menuItemsHoverColor
                                                                        : "transparent",
                                                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                                fontWeight: 600
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,

                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isDisabled={disabled}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        name="fromvehicleClass"
                                                        value={AllFromLocationVehicleClassesOptions.find(
                                                            (item) => item.value === fromVehicleClassId
                                                        )}
                                                        onChange={(vehicleClass: any) =>
                                                            setFromVehicleClassId(
                                                                vehicleClass ? vehicleClass.value : ""
                                                            )
                                                        }
                                                        options={AllFromLocationVehicleClassesOptions}
                                                    />
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>From Secondary Vehicle Class</label>
                                                    <Select
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: "transparent",
                                                                color: themeStyles.form.inputTextColor,
                                                                borderRadius: '6px',
                                                                padding: '1px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "14px",
                                                                backgroundColor: themeStyles.main.mainBg,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                            option: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: state.isSelected
                                                                    ? "#167AC3"
                                                                    : state.isFocused
                                                                        ? themeStyles.topBar.menuItemsHoverColor
                                                                        : "transparent",
                                                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                                fontWeight: 600
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,

                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isDisabled={disabled}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        name="fromvehicleSecondaryClass"
                                                        value={AllFromLocationVehicleClassesOptions.find(
                                                            (item) => item.value === fromSecondaryVehicleClassId
                                                        )}
                                                        onChange={(vehicleClass: any) =>
                                                            setFromSecondaryVehicleClassId(
                                                                vehicleClass ? vehicleClass.value : ""
                                                            )
                                                        }
                                                        options={AllFromLocationVehicleClassesOptions}
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Relocation Charge</label>
                                                    <input
                                                        type="number"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={relocationCharge}
                                                        min={0}
                                                        step={0.01}
                                                        onChange={(e) => {
                                                            setRelocationCharge(validateMin(e.target.value, 0))
                                                        }}
                                                        disabled={disabled}
                                                    />
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>To Location</label>
                                                    <Select
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: "transparent",
                                                                color: themeStyles.form.inputTextColor,
                                                                borderRadius: '6px',
                                                                padding: '1px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "14px",
                                                                backgroundColor: themeStyles.main.mainBg,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                            option: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: state.isSelected
                                                                    ? "#167AC3"
                                                                    : state.isFocused
                                                                        ? themeStyles.topBar.menuItemsHoverColor
                                                                        : "transparent",
                                                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                                fontWeight: 600
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,

                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isDisabled={disabled}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isRtl={false}
                                                        required={true}
                                                        isSearchable={false}
                                                        name="tolocation"
                                                        value={allLocationsOptions.find(
                                                            (item) => item.value === toLocationId
                                                        )}
                                                        onChange={(location: any) => {
                                                            setToLocationId(
                                                                location ? location.value : 0
                                                            )
                                                            setToLocationBranchId(location ? location.branchId : 0)
                                                        }}
                                                        options={allLocationsOptions}
                                                    />
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>To Vehicle Class</label>
                                                    <Select
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: "transparent",
                                                                color: themeStyles.form.inputTextColor,
                                                                borderRadius: '6px',
                                                                padding: '1px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "14px",
                                                                backgroundColor: themeStyles.main.mainBg,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                            option: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: state.isSelected
                                                                    ? "#167AC3"
                                                                    : state.isFocused
                                                                        ? themeStyles.topBar.menuItemsHoverColor
                                                                        : "transparent",
                                                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                                fontWeight: 600
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,

                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isDisabled={disabled}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        required={true}
                                                        name="tovehicleClass"
                                                        value={AllToLocationVehicleClassesOptions.find(
                                                            (item) => item.value === toVehicleClassId
                                                        )}
                                                        onChange={(vehicleClass: any) =>
                                                            setToVehicleClassId(
                                                                vehicleClass ? vehicleClass.value : ""
                                                            )
                                                        }
                                                        options={AllToLocationVehicleClassesOptions}
                                                    />
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>To Secondary Vehicle Class</label>
                                                    <Select
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: "transparent",
                                                                color: themeStyles.form.inputTextColor,
                                                                borderRadius: '6px',
                                                                padding: '1px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "14px",
                                                                backgroundColor: themeStyles.main.mainBg,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                            option: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: state.isSelected
                                                                    ? "#167AC3"
                                                                    : state.isFocused
                                                                        ? themeStyles.topBar.menuItemsHoverColor
                                                                        : "transparent",
                                                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                                fontWeight: 600
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,

                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isDisabled={disabled}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        required={true}
                                                        name="tovehicleSecondaryClass"
                                                        value={AllToLocationVehicleClassesOptions.find(
                                                            (item) => item.value === toSecondaryVehicleClassId
                                                        )}
                                                        onChange={(vehicleClass: any) =>
                                                            setToSecondaryVehicleClassId(
                                                                vehicleClass ? vehicleClass.value : ""
                                                            )
                                                        }
                                                        options={AllToLocationVehicleClassesOptions}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex gap-4 mt-6">
                                            {
                                                !disabled && (
                                                    <Button
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.main.bg,
                                                            '&.Mui-disabled': {
                                                                backgroundColor: '#ccc',
                                                                color: '#666',
                                                            },
                                                        }}
                                                        type="submit"
                                                    >
                                                        Save
                                                    </Button>
                                                )
                                            }

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => navigate(-1)}
                                            >
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.delete.bg,
                                                }}
                                                onClick={deleteRelocationMapping}
                                            >
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    )
}